import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Colunas from "./components/Colunas";
import Filtros from "./components/Filtros";
import FiltrosDinamicos from "./components/FiltrosDinamicos";
import Empresas from "./components/Empresas";
import { ExportRelatorioContext } from "./ExportRelatorioContext";
import styles from "./styles.module.css";
import BtnOptionExport from "./btnOptionExport";
import CloseIcon from "@mui/icons-material/Close";
import {
  buscarRelatoriosPorCodigo,
  exportarRelatorio,
} from "../../services/api-relatorios.service";
import { isRelatorioIcmsSt } from "../../utils/relatorioIcmsSt.util";
import ExtracaoIcmsStForm from "../ExtracaoIcmsSt/ExtracaoIcmsStForm";
import ModalFilaCsvDinamica from "../ModalFilaCsvDinamica/ModalFilaCsvDinamica";
import MensagemSucesso from "../MensagemSucesso";
import MensagemErro from "../MensagemErro";
import DescriptionIcon from "@mui/icons-material/Description";
import SaveFilter from "../../pages/ExtratorRelatorios/FiltroSalvos/SaveFilter";
import Loading from "../Loading";

const styleButton = {
  border: "1px solid #18316E",
  borderRadius: "20px",
  color: "#18316E",
  "&:hover": {
    backgroundColor: "#d0daf5",
  },
};

const NovoExportador = ({
  allowbutton,
  label,
  codRelatorio,
  handleModal,
  close,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [typeData, setTypeData] = useState("csv");
  const [loading, setLoading] = useState(false);
  const [hasSchema, setHasSchema] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState({
    nome: "",
    colunas: [],
    filtros: [],
  });
  const [snackBar, setSnackBar] = useState({
    error: false,
    success: false,
    msg: "",
  });
  const {
    handleClose,
    empresas,
    filtros,
    valoresFiltros,
    colunas,
    penddingSave,
    setPenddingSave,
    apuracao,
    setApuracao,
  } = useContext(ExportRelatorioContext);

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const response = await buscarRelatoriosPorCodigo(codRelatorio);
        const relatorio = response.relatorios[0];
        setDadosRelatorio(relatorio);
        // Usa hasSchema da API quando existir (ex.: SPED_ECD_REGISTRO_I250); senão mantém lógica pelo script
        setHasSchema(relatorio.hasSchema ?? (relatorio.script && (
          relatorio.script.includes("${schema}") ||
          relatorio.script.includes("${schemas")
        )));
        setApuracao(response.relatorios[0].apuracao ?? false);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    if (openModal) fetch();
  }, [openModal, codRelatorio]);

  useEffect(() => {
    const handleCloseOropen = () => {
      if (handleModal) {
        setOpenModal(true);
      } else {
        handleCloseModal();
      }
    };

    handleCloseOropen();
  }, [handleModal]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    handleClose();
    if (!allowbutton) {
      close(true);
    }
  };

  const handleSnackBar = (action, type, msg) => {
    switch (type) {
      case "erro":
        setSnackBar({
          ...snackBar,
          error: action,
          msg: msg ?? "",
        });
        break;
      case "sucesso":
        setSnackBar({
          ...snackBar,
          success: action,
          msg: msg ?? "",
        });
        break;

      default:
        break;
    }
  };

  const handleSubmit = async () => {
    console.log("Isso precisa estar true: ", penddingSave.pendding);
    if (penddingSave.pendding) {
      handleSnackBar(true, "erro", "O filtro não foi salvo");
      setPenddingSave({
        ...penddingSave,
        helpertext:
          "É necessário salvar o filtro antes da extração, caso deseje salvar estas predefinições.",
        error: true,
      });
      return;
    }

    // Helpers
    const isEmpty = (v) => v == null || (Array.isArray(v) && v.length === 0) || (typeof v === 'string' && v.trim() === "");
    const toYMD = (input) => {
      if (!input) return null;
      
      // Se já está no formato YYYY-MM-DD, retorna como está
      if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
        return input;
      }
      
      // Se é um objeto Date, usa diretamente
      let d;
      if (input instanceof Date) {
        d = input;
      } else {
        d = new Date(input);
      }
      
      // Verifica se a data é válida
      if (isNaN(d.getTime())) return null;
      
      // Verifica se a data é válida (não é 1970-01-01 para datas inválidas)
      if (d.getTime() < 0) return null;
      
      // Verifica se o ano é razoável (entre 1900 e 2100)
      const year = d.getFullYear();
      if (year < 1900 || year > 2100) return null;
      
      const yyyy = year;
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };
    // Remove aspas e quaisquer caracteres de controle (CR/LF/TAB) mantendo pontuação dos códigos
    const sanitizeStr = (s) => `${s}`
      .replace(/["']/g, '')
      .replace(/[\r\n\t]/g, '')
      .trim();
    const buildCsvQuoted = (arr) => arr
      .map((s) => `'${sanitizeStr(s).replace(/'/g, "''")}'`)
      .join(', ');

    // Validação para Contas Contábeis obrigatórias
    // Só bloqueia se o filtro estiver marcado/ativo E sem nenhuma conta selecionada
    const contasAtiva = filtros.some(
      (f) =>
        f.nome === "Contas Contábeis" ||
        f.variavel === "$F{contas_contabil}" ||
        f.variavel === "$F{contas_contabeis}"
    );
    const contasContabeisFilter = valoresFiltros.find(
      (filtro) =>
        filtro.nome === "Contas Contábeis" ||
        filtro.variavel === "$F{contas_contabil}" ||
        filtro.variavel === "$F{contas_contabeis}"
    );
    const contasValor = contasContabeisFilter ? contasContabeisFilter.valor : null;
    const isEmptyContas = isEmpty(contasValor);
    if (contasAtiva && isEmptyContas) {
      handleSnackBar(true, "erro", "Selecione ao menos uma conta contábil para gerar o relatório.");
      return;
    }

    // Validação obrigatória para datas (evitar "invalid input syntax for type date: \"\"")
    const dataInicial = valoresFiltros.find(f => f.nome === "Data Inicial" || f.variavel === "$F{dt_inicial}");
    const dataFinal = valoresFiltros.find(f => f.nome === "Data Final" || f.nome === "Data Fim" || f.variavel === "$F{dt_final}" || f.variavel === "$F{dt_fim}");
    
    // Verifica se existem filtros de data e se estão preenchidos
    const hasDataFilters = dataInicial || dataFinal;
    const hasInitialDate = dataInicial && !isEmpty(dataInicial.valor) && dataInicial.valor !== "";
    const hasFinalDate = dataFinal && !isEmpty(dataFinal.valor) && dataFinal.valor !== "";
    
    if (hasDataFilters && (!hasInitialDate || !hasFinalDate)) {
      const missingDates = [];
      if (!hasInitialDate) missingDates.push("Data Inicial");
      if (!hasFinalDate) missingDates.push("Data Final");
      handleSnackBar(true, "erro", `Informe ${missingDates.join(" e ")} para gerar o relatório.`);
      return;
    }

    setLoading(true);
    if (process.env.NODE_ENV !== 'production') console.time('buildFilters');
    let newSchemas = null;
    if (hasSchema && empresas.length > 0) {
      newSchemas = empresas.map((item) => {
        return `z_${item.id}`;
      });
    }

    // Pré-cálculo das datas normalizadas (reduz buscas e parse repetidos)
    const diSrc = valoresFiltros.find(f => f.variavel === "$F{dt_inicial}");
    const dfSrc = valoresFiltros.find(f => f.variavel === "$F{dt_final}" || f.variavel === "$F{dt_fim}");
    const diISOpre = Array.isArray(diSrc?.valores) ? diSrc?.valores[0] : diSrc?.valor;
    const dfISOpre = Array.isArray(dfSrc?.valores) ? dfSrc?.valores[0] : dfSrc?.valor;
    
    // Se apuração está ativada, ajusta as datas para primeiro e último dia do mês
    // IMPORTANTE: Usa diretamente o objeto Date original para evitar problemas de timezone
    let diYMDpre = null;
    let dfYMDpre = null;
    
    if (apuracao) {
      if (diISOpre) {
        // Data inicial: primeiro dia do mês
        // diISOpre já é um Date object do GenericDatePickerReference
        const d = diISOpre instanceof Date ? diISOpre : new Date(diISOpre);
        if (!isNaN(d.getTime())) {
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          diYMDpre = `${year}-${month}-01`;
        }
      }
      if (dfISOpre) {
        // Data final: último dia do mês
        // dfISOpre já é um Date object do GenericDatePickerReference
        const d = dfISOpre instanceof Date ? dfISOpre : new Date(dfISOpre);
        if (!isNaN(d.getTime())) {
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          // Usa o mesmo mês/ano do objeto Date original
          const lastDay = new Date(year, d.getMonth() + 1, 0).getDate();
          dfYMDpre = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
        }
      }
    } else {
      // Se não for apuração, converte normalmente
      diYMDpre = (diISOpre && diISOpre !== "" && diISOpre !== null) ? toYMD(diISOpre) : null;
      dfYMDpre = (dfISOpre && dfISOpre !== "" && dfISOpre !== null) ? toYMD(dfISOpre) : null;
    }

    // Cache de parametros por script para evitar regex repetidas
    const parametrosCache = new Map();
    const getParametros = (script) => {
      if (!script) return [];
      const key = String(script);
      if (parametrosCache.has(key)) return parametrosCache.get(key);
      const arr = key.match(/\$P!?\{[^}]*\}/g) || [];
      parametrosCache.set(key, arr);
      return arr;
    };

    const newFiltros = valoresFiltros.length > 0
      ? valoresFiltros
        // Remove filtros sem valor (evita envio de strings vazias e listas vazias)
        .filter((item) => !isEmpty(item?.valor) || !isEmpty(item?.valores))
        .map((item) => {
          const parametros = getParametros(item.script);

          // Tratamento especial para datas obrigatórias (sempre YYYY-MM-DD)
          if (item.variavel === "$F{dt_inicial}" || item.variavel === "$F{dt_final}" || item.variavel === "$F{dt_fim}") {
            const hasBoth = parametros.includes("$P{dt_inicial}") && parametros.includes("$P{dt_final}");
            const diYMD = diYMDpre;
            const dfYMD = dfYMDpre;
            if (!diYMD || !dfYMD) {
              const missingDates = [];
              if (!diYMD) missingDates.push("Data Inicial");
              if (!dfYMD) missingDates.push("Data Final");
              
              throw new Error(`${missingDates.join(" e ")} inválida(s). Use datas válidas (YYYY-MM-DD).`);
            }

            // Ordena os valores conforme a ordem dos parametros
            const orderedValores = hasBoth
              ? parametros.map(p => p.includes("dt_inicial") ? diYMD : dfYMD)
              : [item.variavel === "$F{dt_inicial}" ? diYMD : dfYMD];

            const selfValue = (item.variavel === "$F{dt_inicial}") ? diYMD : dfYMD;

            return {
              ...item,
              parametros,
              valor: selfValue,
              valores: orderedValores
            };
          }
          // Modo de saída (relatórios que usam p_notas_saida no script genérico)
          if (item.variavel === "$F{p_notas_saida}" || item.nome === "Modo de saída") {
            const modo = (item.valor && String(item.valor).toUpperCase().trim()) || "CRUZADAS";
            const modoValido = modo === "TODAS" ? "TODAS" : "CRUZADAS";
            return {
              ...item,
              parametros: ["$P{p_notas_saida}"],
              valor: modoValido,
              valores: [modoValido]
            };
          }
          // Tratamento especial para Contas Contábeis (sempre substituição textual)
            if (item.nome === "Contas Contábeis" || item.variavel === "$F{contas_contabil}" || item.variavel === "$F{contas_contabeis}") {
              let contasArray = [];
              
              // PRIORIDADE 1: Se item.valor é um array (formato esperado)
              if (Array.isArray(item.valor)) {
                contasArray = item.valor
                  .filter((v) => v !== "__SELECIONAR_TODOS__" && v !== "__SELECIONAR_RESULTADO__" && v !== null && v !== undefined && v !== "")
                  .map((v) => sanitizeStr(String(v))); // Garante que seja string
              } 
              // PRIORIDADE 2: Se item.valor é uma string (formato "'10164'" ou "'10164','10165'")
              else if (typeof item.valor === 'string') {
                // Remove aspas simples e divide por vírgula
                const valorLimpo = item.valor.replace(/'/g, '').trim();
                if (valorLimpo) {
                  contasArray = valorLimpo
                    .split(/[,;\n\r\t]+/)
                    .map((v) => sanitizeStr(v.trim()))
                    .filter((v) => v !== "__SELECIONAR_TODOS__" && v !== "__SELECIONAR_RESULTADO__" && Boolean(v));
                }
              } 
              // PRIORIDADE 3: Se item.valores é um array
              else if (Array.isArray(item.valores)) {
                contasArray = item.valores
                  .filter((v) => v !== "__SELECIONAR_TODOS__" && v !== "__SELECIONAR_RESULTADO__")
                  .map((v) => sanitizeStr(String(v)));
              }

              // Remove vazios e duplicatas
              contasArray = Array.from(new Set(contasArray.filter(Boolean)));
              if (contasArray.length === 0) return null; // evita IN()/ARRAY[]

              // CRÍTICO: Garante que todos os valores sejam strings explícitas
              // O PostgreSQL precisa de strings para ARRAY[]::TEXT[]
              // IMPORTANTE: Valores como "1.1.1.01.00003" precisam ser strings, não números
              contasArray = contasArray.map((v) => {
                const str = String(v);
                // Garante que valores numéricos ou com pontos sejam sempre tratados como strings
                // Remove espaços e garante que não seja vazio
                return str.trim();
              });

              const valorSQL = buildCsvQuoted(contasArray);
              // Validação extra: garante CSV válido entre aspas simples, sem vírgula final
              const csvOk = /^'(?:[^']|'{2})+'(?:,\s*'(?:[^']|'{2})+')*$/.test(valorSQL);
              if (!csvOk) {
                throw new Error('Lista de contas inválida. Remova caracteres especiais e tente novamente.');
              }

              // CRÍTICO: Para Contas Contábeis, SEMPRE envia o array no campo 'valores'
              // O backend usa esse array para preencher ARRAY[]::TEXT[] mesmo que o script não mostre explicitamente
              // IMPORTANTE: Os valores DEVEM ser strings explícitas para evitar que o PostgreSQL os interprete como números
              return {
                ...item,
                parametros,
                valor: valorSQL,
                valores: contasArray // SEMPRE envia o array de strings para que o backend gere ARRAY['1.1.1.01.00003']::TEXT[]
              };
            }





          // Tratamento padrão para outros filtros
          const defaultValor =
            Array.isArray(item.valor) && item.valor.length > 0
              ? `[${item.valor.map((v) => `"${sanitizeStr(v)}"`).join(',')}]`
              : typeof item.valor === 'string'
                ? `"${sanitizeStr(item.valor)}"`
                : item.valor;

          return {
            ...item,
            parametros,
            valor: defaultValor,
            valores: Array.isArray(item.valores) ? item.valores : (item.valores ? [item.valores] : [])
          };
        })
        // Remove itens nulos do mapeamento (ex.: Contas Contábeis vazio após saneamento)
        .filter(Boolean)
      : null;
    if (process.env.NODE_ENV !== 'production') console.timeEnd('buildFilters');

    // STOP-GAP extra: evita envio de dados malformados
    if (
      newFiltros?.some(
        (f) => typeof f?.valor === 'string' && (/\bNaN\b/.test(f.valor) || /,\s*$/.test(f.valor))
      )
    ) {
      handleSnackBar(true, 'erro', 'Há filtros inválidos (datas ou lista de contas). Revise e tente novamente.');
      setLoading(false);
      return;
    }

    const body = {
      idRelatorio: dadosRelatorio.idRelatorio,
      nomeRelatorio: dadosRelatorio.nome,
      colunas: colunas.length > 0 ? colunas : null,
      filtros: newFiltros || [],
      schemas: newSchemas,
    };

    try {
      if (process.env.NODE_ENV !== 'production') console.time('exportarRelatorio');
      const response = await exportarRelatorio(body, typeData);
      if (process.env.NODE_ENV !== 'production') console.timeEnd('exportarRelatorio');

      switch (typeData) {
        case "csv":
        case "excel":
          if (response.size) {
            const blob = new Blob([response], {
              type: "text/csv;charset=utf-8",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${dadosRelatorio.nome}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            handleSnackBar(true, "sucesso", "Relatório gerado com sucesso!");
          } else {
            throw new Error(response.mensagem);
          }

          break;
        case "pdf":
          if (response.arquivoPdf) {
            const buffer = new Uint8Array(response.arquivoPdf.data);
            const pdfBlob = new Blob([buffer], {
              type: "application/octet-stream",
            });

            const pdfUrl = window.URL.createObjectURL(pdfBlob);
            const linkDownloadPdf = document.createElement("a");

            linkDownloadPdf.href = pdfUrl;
            linkDownloadPdf.setAttribute(
              "download",
              `${dadosRelatorio.nome}.pdf`
            );

            document.body.appendChild(linkDownloadPdf);
            linkDownloadPdf.click();
            document.body.removeChild(linkDownloadPdf);
            window.URL.revokeObjectURL(pdfUrl);
            handleSnackBar(true, "sucesso", "Relatório gerado com sucesso!");
          } else {
            throw new Error(response.mensagem);
          }

          break;

        case "ambos":
          if (response) {
            const blob = new Blob([response], {
              type: "application/zip",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${dadosRelatorio.nome.replace(/\./g, "")}.zip`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            handleSnackBar(true, "sucesso", "Relatório gerado com sucesso!");
          } else {
            throw new Error(response.mensagem);
          }
          break;
      }

      handleCloseModal();
      setTypeData("csv");
    } catch (error) {
      console.log(error);
      handleSnackBar(true, "erro", `${error}`);
      setTypeData("csv");
    } finally {
      setLoading(false);
    }
  };

  const handleTypeData = (type) => {
    setTypeData(type);
  };

  const exibirFormularioIcmsSt =
    !loading &&
    isRelatorioIcmsSt(dadosRelatorio.nome, dadosRelatorio.codigoRelatorio);

  return (
    <>
      {allowbutton ? (
        <Button
          startIcon={<DescriptionIcon />}
          sx={styleButton}
          onClick={handleOpenModal}
        >
          {label ?? "Relatório"}
        </Button>
      ) : (
        ""
      )}
      {/* <Button
        startIcon={<DescriptionIcon />}
        sx={styleButton}
        onClick={handleOpenModal}
      >
        {label ?? "Relatório"}
      </Button> */}

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth={loading ? false : true}
        maxWidth={loading ? "sm" : "md"}
      >
        <div>
          <div style={{ display: loading ? "block" : "none" }}>
            <Loading loading={loading} />
          </div>
          <div style={{ display: !loading ? "block" : "none" }}>
            <DialogTitle>{dadosRelatorio.nome}</DialogTitle>
            <DialogContent>
              {dadosRelatorio.processaFilaCsv ? (
                <ModalFilaCsvDinamica
                  relatorio={dadosRelatorio}
                  onClose={handleCloseModal}
                  onFinished={(ok, msg) => {
                    if (ok) {
                      handleSnackBar(true, "sucesso", msg);
                      handleCloseModal();
                    }
                  }}
                />
              ) : exibirFormularioIcmsSt ? (
                <ExtracaoIcmsStForm
                  idRelatorio={dadosRelatorio.idRelatorio}
                  filtros={dadosRelatorio?.filtros}
                  onClose={handleCloseModal}
                  onFinished={(ok, msg) => {
                    if (ok) {
                      handleSnackBar(true, "sucesso", msg);
                      handleCloseModal();
                    }
                  }}
                />
              ) : (
                <>
                  {dadosRelatorio.colunas.length > 0 && (
                    <Colunas options={dadosRelatorio.colunas} />
                  )}
                  {dadosRelatorio.filtros?.length > 0 && (
                    <Filtros options={dadosRelatorio.filtros} />
                  )}
                  {hasSchema && <Empresas />}
                  <FiltrosDinamicos />

                  <SaveFilter
                    idRelatorio={dadosRelatorio.idRelatorio}
                    hasSchema={hasSchema}
                  />

                  <div className={styles.button_container}>
                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={<CloseIcon />}
                      onClick={handleCloseModal}
                    >
                      Cancelar
                    </Button>

                    <BtnOptionExport
                      onClick={handleSubmit}
                      typeData={handleTypeData}
                      dadosRelatorio={dadosRelatorio}
                    />
                  </div>
                </>
              )}
            </DialogContent>
          </div>
        </div>
      </Dialog>
      <MensagemSucesso
        open={snackBar.success}
        handleClose={() => handleSnackBar(false, "sucesso")}
        msg={snackBar.msg}
      />

      <MensagemErro
        open={snackBar.error}
        handleClose={() => handleSnackBar(false, "erro")}
        msg={snackBar.msg}
      />
    </>
  );
};

export default NovoExportador;
